<script lang="ts">
    import CircularProgress from "../../public/icons/circular_progress.svelte";
    import StrikeTypeNote from "./StrikeTypeNote.svelte";
    import {
        LightningStrikeType,
        lightningDelay,
        lightningDelayError,
        Widget,
        widgetInfo,
        WidgetType,
    } from "../store";

    // false when the parent renders the CG note on its own row (narrow IMG / RADAR widgets)
    export let inlineStrikeType: boolean = true;

    let fill: string = "--success-color";
    let delay: string | undefined = undefined;
    let radius: number = 10;
    let radiusTextFill: string = "--default-color";
    let isError: boolean = false;
    let type: WidgetType = WidgetType.DEF;
    let strikeType: LightningStrikeType | undefined = undefined;

    widgetInfo.subscribe((value: Widget) => {
        strikeType = value?.lightningStrikeType;
        if (value != undefined && value.lightningRadius != undefined)
        {
            radius = value.lightningRadius;
            type = value.type;
        }
        
        if (value?.type != WidgetType.DEF) radiusTextFill = "--primary-color";
    });

    lightningDelay.subscribe((value: number) => {
        fill = value > 0 ? "--error-color" : "--success-color";
        let hour: number = Math.floor(value / 3600);
        let remainingSeconds: number = value % 3600;
        let minute: number = Math.floor(remainingSeconds / 60);
        let second: number = Math.floor(remainingSeconds % 60);
        delay =
            value > 0
                ? `${
                      hour < 1 ? "" : hour < 10 ? "0" + hour + ":" : hour + ":"
                  }${minute < 10 ? "0" + minute : minute}:${
                      second < 10 ? "0" + second : second
                  }`
                : undefined;

        if (isError) fill = "--error-color";
    });

    lightningDelayError.subscribe((value: boolean) => {
        isError = value;
    });
</script>

<div class="lightning-timer-container" class:strike-type-cg={inlineStrikeType && strikeType === "CG" && !isError}>
    <div class="lightning-circle">
        <CircularProgress {fill} />
    </div>
    <div class="lightning-info">
        {#if isError}
            <div
                class="timer-label"
                style="color: var({type === WidgetType.DEF ? "--default-color" : "--primary-color"}); margin: 0px; font-weight: 300; height:100%; display: flex; justify-content: center; flex-direction: column; align-items: {type === WidgetType.DEF ? 'center' : 'flex-start'};{type === WidgetType.DEF ? `text-align:center` :''}"
            >
                <span style="font-size: 56px;">Unavailable</span>
                <span style="font-size: 24px;">
                    Lightning status is currently unavailable
                </span>
            </div>
        {:else if delay}
            <div
                class="timer-label"
                style="color: var({fill}); margin: 0px; font-weight: 300;"
            >
                {delay}
            </div>
        {:else}
            <div
                class="timer-label"
                style="color: var({fill}); margin: 0px; font-weight: 300;"
            >
                Clear
            </div>
        {/if}

        {#if !isError}
        <div
        class="radius-label"
        style="margin: 0px; color: var({radiusTextFill});"
        >
            0-{radius} mi
        </div>
        {#if inlineStrikeType}
        <StrikeTypeNote />
        {/if}
        {/if}
    </div>
</div>

<style>
    /* Centre the circle against the taller CG text block (mockup); DEF is already column + centred */
    .strike-type-cg {
        align-items: center;
    }
</style>
